import React,{useEffect,useState} from 'react';
import { Grid,Box,Typography} from '@mui/material';
import { useNavigate } from 'react-router-dom';
// import { LineChart, Line, XAxis, YAxis, CartesianGrid, Legend,Tooltip, ResponsiveContainer } from 'recharts';
// import {ChartAxis, ChartBullet } from '@patternfly/react-charts';
// import { dir } from 'console';
// import { position } from 'stylis';
import TOCart from '../TOCart/TOCart';

const TeamDetail = (props:any) => {
    const navigate=useNavigate()
    let{kr,namee,num}=props || {};
    let{name,verticalKeyResultTeamsObjective}=kr || {};

    const[allobj,setAllObj]=useState<any[]>();

    // let{keyResults}=obj || {};
    useEffect(() => {
      setAllObj(verticalKeyResultTeamsObjective)
  
    }, [verticalKeyResultTeamsObjective])


  return (  
    
    <Grid container boxShadow={4} bgcolor={'white'} borderRadius={4} p={2} width={'100%'} >
        <Grid item xs={12}  >
        <Grid container >
        <Grid item xs={12}  >
        <Box 
        display={'flex'} 
        width={'100%'}
        flexDirection={'row-reverse'}
        justifyContent={'start'} > 
        
        <Box 
        display={'flex'} 
        width={'100%'}
       >
        {
          namee === "WithOut" ?
          <Typography  variant='body1' fontWeight={900} color={'#000'}  fontSize={'15px'} >
             هدف {num + 1} :{name}
        </Typography> :
        <Typography px={1}  variant='body1' color={'#000'} fontSize={'15px'}  fontWeight={900} >
        نام تیم: { name }
        </Typography>
        }
        
        </Box>
        </Box>
        </Grid>
      </Grid>
        </Grid>
        <Grid item xs={12}  >
        <Box 
        display={'flex'} 
        width={'100%'}
        flexDirection={'row-reverse'}
        justifyContent={'space-around'} > 
      </Box>
        </Grid>
        <Grid item xs={12}  >
         {
          allobj !== null && allobj !== undefined && allobj.length>0 &&  <Grid container  >
          <Grid item xs={12}  >
         
            <Grid container spacing={1} px={1} >
 
           {
            allobj && allobj.map((o:any,i:number)=>{
              return <Grid  item xs={12} sm={12}  >
                <Box width={'100%'} key={i}   >
                <TOCart objj={o}   
                item={o}
                num = {i}
                namee={namee}
                />
              </Box>
              </Grid>
            })
          }
           </Grid> 
          </Grid>
         </Grid>
         }
        </Grid>

   </Grid>
  )
}

export default TeamDetail